<script setup lang="ts">
import CLanguageDrop from '@/components/Settings/CLanguageDrop.vue'
import { IconMail, IconNumber123 } from '@tabler/icons-vue'
import CPasswordInput from '@/components/Forms/Input/CPasswordInput.vue'

const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)
const APP_NAME = import.meta.env.VITE_APP_NAME
const userStore = useUserStore()
const { doLogin } = userStore
const { loginError } = storeToRefs(userStore)
const email = ref(null)
const password = ref(null)
const code = ref(null)
const loading = ref(false)
const { t } = useI18n()

async function submitLogin(event) {
  event.preventDefault()
  loading.value = true
  await doLogin(email.value, password.value, code.value)
  loading.value = false
}
</script>

<template>
  <div>
    <div class="bg-light">
      <CContainer class="d-flex flex-column min-vh-100 justify-content-between">
        <CRow>
          <CCol class="d-flex mt-3 mb-3 d-flex justify-content-end"></CCol>
        </CRow>
        <CRow class="justify-content-center align-items-center">
          <CCol :xs="12" :md="12" :lg="8">
            <CCardGroup>
              <CCard class="p-4">
                <CCardBody>
                  <CForm @submit="e => submitLogin(e)">
                    <CImage
                      v-if="theme === 'dark'"
                      fluid
                      src="/logo-bmotion-blanco-sm.png"
                      style="max-width: 100px; width: 50%; margin-left: -8px; margin-bottom: 4px"
                    />
                    <CImage
                      v-if="theme === 'light'"
                      fluid
                      src="/logo-bmotion-negro-sm.png"
                      style="max-width: 100px; width: 50%; margin-left: -8px; margin-bottom: 4px"
                    />
                    <h4>
                      <strong>{{ APP_NAME }}</strong>
                    </h4>
                    <p class="text-medium-emphasis">
                      {{ t('To access the application as a company') }}
                    </p>
                    <CAlert v-if="loginError" color="danger">
                      <ul class="mb-0">
                        <template v-for="(error, index) in loginError" :key="index">
                          <li v-for="(messageError, indexMessageError) in error" :key="indexMessageError">
                            {{ t(messageError) }}
                          </li>
                        </template>
                      </ul>
                    </CAlert>

                    <CInputGroup class="mb-3">
                      <CInputGroupText>
                        <IconMail stroke-width="1" />
                      </CInputGroupText>
                      <CFormInput :placeholder="t('E-mail')" v-model="email" />
                    </CInputGroup>

                    <CPasswordInput v-model="password" mode="placeholder" class="mb-3" />
                    <CInputGroup class="mb-3">
                      <CInputGroupText>
                        <IconNumber123 stroke-width="1" />
                      </CInputGroupText>
                      <CFormInput :placeholder="t('Code')" v-model="code" />
                    </CInputGroup>
                    <CRow class="mb-4">
                      <CCol :xs="12" class="text-left pt-2">
                        <router-link :to="'/forgot-password'">
                          <small>{{ t('Have you forgotten your password?') }}</small>
                        </router-link>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol :xs="12" class="d-flex justify-content-end">
                        <CLoadingButton
                          color="primary"
                          type="submit"
                          class="px-4"
                          :loading="loading"
                          :disabled="loading"
                        >
                          {{ t('Login') }}
                        </CLoadingButton>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <div class="g-recaptcha" data-sitekey="your_site_key"></div>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                class="login-text d-flex flex-column justify-content-center align-items-center p-4 py-5"
                style="width: 100%"
              >
                <CCardBody class="text-center">
                  <div>
                    <h5 class="p-3" style="font-weight: 400">
                      {{ t(`Technology is our strength, service is our passion.`) }}.
                    </h5>
                    <p style="font-weight: 300">
                      {{
                        t(
                          `Tools focused on managing and executing your digital, hybrid, and in-person congresses and events in the most efficient way possible.`
                        )
                      }}
                    </p>
                    <a href="https://bmotionav.com">
                      <CLoadingButton color="secondary" variant="outline" class="mt-3">
                        {{ t('Find out more') }}
                      </CLoadingButton>
                    </a>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-center mb-3 mb-md-0">
          <div class="text-center">
            <CLanguageDrop mode="flag-name" />
          </div>
          <small class="text-center ms-0 ms-md-4">
            BMOTION AUDIOVISUAL SL., CIF:B59825075, C\Forjadores, 32, (PQ. Empresarial Prado Espino), 28660, Boadilla
            del Monte, Madrid.
          </small>
        </div>
      </CContainer>
    </div>
  </div>
</template>
